import React from 'react';

import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {QueryResultType} from 'graphql-client/BenchlingQuery';

import {getDocumentIdFromStep} from './OutputsUtil';
import useDocumentMetadata from './useDocumentMetadata';

export interface DocumentNameProps {
  step: GetAnalysisPipelineStep;
}

/**
 * Show the name of the document, for a SEND_TO_DOCUMENT step.
 *
 * Supports entries, worksheets, and documents (i.e. steps within worksheets).
 */
export default function DocumentName({step}: DocumentNameProps): JSX.Element {
  const metadataQuery = useDocumentMetadata(getDocumentIdFromStep(step));

  switch (metadataQuery.status) {
    case QueryResultType.PENDING:
      return <>Loading...</>;
    case QueryResultType.ERROR:
      return <>Inaccessible</>;
    default:
      return <>{metadataQuery.name}</>;
  }
}
